export { default as TestimonialSlide } from './TestimonialSlide';
export { default as ProductSlide } from './ProductSlide';
export { default as ShopBySlide } from './ShopBySlide';
export { default as ShopAnchorSlide } from './ShopAnchorSlide';
export { default as ShopAnchorSlideSticky } from './ShopAnchorSlideSticky';
export { default as ShopAnchorSwiper } from './ShopAnchorSwiper';
